<template>
  <div class="crm-homedetail-page" v-if="promotionDetail">
    <ThemeBackgroundPromotion :showBack="true" />
    <el-row class="crm-drawer-entry">
      <el-col>
        <div class="tag-pause mb-3" v-if="!promotionDetail.outOfStockFlag">{{ $t('components.promotion.pause') }}</div>
        <h2 class="text-1-line">{{ promotionDetail.name }}</h2>
        <div class="crm-drawer-entry-point mb-3" v-if="( startDate || endDate) || !promotionDetail.proAddFriend">
        <!-- <div class="crm-drawer-entry-point mb-5" v-if="promotionDetail.isPrivilege && !promotionDetail.proAddFriend"> -->
          <img class="ma-0" :src="require(`@/assets/svg/calendar.svg?inline`)" alt=""/>
          <span class="text-period ml-2">{{ $t('components.promotion.time-period') }} :  {{ startDate }} - {{ endDate }}</span>
        </div>
        <div class="crm-drawer-entry-point mb-3" v-if="promotionDetail.quotaLimit">
          <img class="ma-0" :src="require(`@/assets/svg/ticket.svg?inline`)" alt=""/>
          <span class="text-period ml-2">{{ $t('components.promotion.promotion-available') }} :  {{promotionDetail.quotaRemain}}</span>
        </div>
        <div class="crm-drawer-entry-point mb-3" v-if="parseInt(promotionDetail.point) != 0">
          <points />
          <label class="crm-drawer-point text-1-line">
            {{ numberWithCommas(promotionDetail.point) }} {{ $t('register.point') }}</label
          >
        </div>
      </el-col>
      <el-col
        class="crm-drawer-entry-descript mb-4"
      >
        <p class="my-0 break-spaces">{{ promotionDetail.detail }}</p>
      </el-col>
      <el-col class="crm-drawer-entry-footer d-flex-center">
        <div
          class="crm-drawer-error pb-3"
          v-if="!isCanRedeem"
          :style="isCanRedeem ? 'visibility: hidden;' : ''"
        >
          <em class="el-icon-warning-outline"></em>
          <label class="text-1-line">{{ $t('promotion-detail.not-enough-point') }}</label>
        </div>
        <div class="crm-drawer-error pb-3" v-else-if="!promotionDetail.haveQuota">
          <em class="el-icon-warning-outline"></em>
          <label class="text-1-line"> {{ $t('components.history.privilege-full') }} </label>
        </div>
        <el-button
          @click="handlerRedeemCode"
          :type="isCanRedeem && promotionDetail.haveQuota && promotionDetail.outOfStockFlag ? 'crm-foodstory' : 'crm-foodstory-disable'"
          :disabled="!isCanRedeem || !promotionDetail.haveQuota || !promotionDetail.outOfStockFlag"
        >
          {{ $t('promotion-detail.redeem') }}
        </el-button>
      </el-col>
    </el-row>
    <DrawerRedeemCode
      :isOpen="isOpen"
      :promotion="promotionDetail"
      :closeDrawer="closeDrawer"
    />
    <!-- dialog ไปเชื่อมไลน์-->
    <crm-dialog
      :visible="connectLineDialog"
      @close="goToProfilepage"
      width="87%"
    >
      <div class="flex-column">
        <lottie-player
          src="https://lottie.host/f9f16b26-1e47-4fe7-a1ae-1fc0f151460a/Fg1zEY2fyI.json"
          background="transparent"
          speed="1"
          style="width: 162px; height: 98px; margin-bottom:16px"
          loop
          autoplay
        ></lottie-player>
        <span class="text-topic-dialog"> {{ $t('components.promotion.connect-line') }}</span>
        <span class="test-description-dialog"> {{ $t('components.promotion.connect-line-desciption') }}</span>
      </div>
      <template class="dialog-footer">
        <el-button
          class="ok-btn"
          type="primary"
          @click="goToProfilepage"
          v-loading.fullscreen.lock="fullscreenLoading"
          >{{ $t('components.promotion.login-line') }}</el-button
        >
      </template>
  </crm-dialog>
  <!-- dialog ไปเป็นเพื่อนกันเถอะ -->
    <crm-dialog
        :visible="addFriendDialog"
        @close="goToProfilepage"
        width="87%"
      >
      <div class="flex-column">
        <lottie-player
          src="https://lottie.host/15d80fd9-aba1-4010-a4b3-9aa54a226af4/PownSEuzfk.json"
          background="transparent"
          speed="1"
          style="width: 140px; height: 125px; margin:24px 0 16px"
          loop
          autoplay
        ></lottie-player>
        <span class="text-topic-dialog"> {{ $t('components.promotion.add-line') }}</span>
        <span class="test-description-dialog"> {{ $t('components.promotion.add-line-desciption') }}</span>
      </div>
      <template  class="dialog-footer">
        <el-button
          class="ok-btn"
          type="primary"
          @click="goToAddFriends"
          v-loading.fullscreen.lock="fullscreenLoading"
          >{{ $t('components.promotion.add-friend') }}</el-button
        >
      </template>
    </crm-dialog>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import lineAPI from "@api/line-api";
import DrawerRedeemCode from "@/components/elements/DrawerRedeemCode";
import ThemeBackgroundPromotion from "@components/promotion/ThemeBackgroundPromotion";
import CrmDialog from "@/components/Dialog";
import Points from "@/components/icons/Points.vue";
import moment from "moment";
import mixins from "@/helper/mixins";
import GATracking from "@/helper/GATrackingMixins";

export default {
  mixins: [mixins, GATracking],
  components: {
    DrawerRedeemCode,
    ThemeBackgroundPromotion,
    Points,
    CrmDialog
  },
  data() {
    return {
      moment,
      isCanRedeem: true,
      isOpen: false,
      startDate: null,
      endDate: null,
      REDIRECT_URI: process.env.VUE_APP_AUTH_LINE_REDIRECT_PROFILE_URI,
      addFriendDialog: false,
      connectLineDialog : false,
      fullscreenLoading: false
    };
  },
  computed: {
    ...mapGetters({
      promotionDetail: "promotion/promotionDetail",
      userInfo: "user/userInfo",
      restaurantUUID: "restaurant/restaurantUUID",
      restaurantInfo: 'restaurant/restaurantInfo',
      branchUUID: "branch/branchUUID",
      lineFriendToken : "user/lineFriendToken",
      redeemingAddFriend : "promotion/redeemingAddFriend"
    }),
  },
  async mounted() {
    this.setRedeeming( this.redeemingAddFriend == true? false: true ) 
    // Not have promotion detail redirect to home page
    if (this.promotionDetail === null) {
      this.$router.push({
        name: "Home",
        params: {
          restaurant_aliase: this.restaurantUUID,
          branch_aliase: this.branchUUID,
        },
      });
    }
    this.trackActivity(5, 'RedeemCRMPromotion', 'view');

    if(this.promotionDetail && this.promotionDetail.startDate && this.promotionDetail.endDate ){
      const lang = localStorage.getItem('lang') || 'th'
      const startDate = this.promotionDetail.startDate
      const endDate = this.promotionDetail.endDate
      this.moment.locale(lang)
      if(lang == 'th'){
        const [ys,ms,ds] = startDate.split('-')
        const [ye,me,de] = endDate.split('-')
        this.startDate = this.moment(startDate).format("DD MMM ")+(!isNaN(ys)?Number(ys)+543:ys);
        this.endDate = this.moment(endDate).format("DD MMM ")+(!isNaN(ye)?Number(ye)+543:ye);
      }else{
        this.startDate = this.moment(startDate).format("DD MMM YYYY");
        this.endDate = this.moment(endDate).format("DD MMM YYYY");
      }
    }
    // Set display redeem point
    if (this.userInfo)
      if ( this.userInfo.point && this.userInfo.point < this.promotionDetail.point)
        this.isCanRedeem = false;
  },
  methods: {
    ...mapActions({
      redirectLine: "auth/redirectLine",
      redirectToAddFriendLine: "auth/redirectToAddFriendLine"
    }),
     ...mapMutations({
      setPromotionDetail: "promotion/SET_PROMOTION_DETAIL",
      setRedeeming : "promotion/SET_REDEEMING_ADD_FRIEND",
      setLineFriendToken: "user/SET_LINE_FRIEND_TOKEN",
    }),
    async handlerRedeemCode() {
      this.trackActivity(6, 'RedeemCRMPromotion');
      if( this.isCanRedeem && this.promotionDetail.haveQuota && this.promotionDetail.outOfStockFlag){
        //เช็ค api ว่ารับโปรได้ไหม เคยเป็นเพื่อนกันมาหรือยัง 
        //ขึ้น ล็อคอินไลน์เพื่อนขอ token ไปเช็คเพื่อน
        if(this.promotionDetail.proAddFriend && !this.userInfo.isFriend ){
          await this.setPromotionDetail(this.promotionDetail)
          this.setRedeeming(true)
          if(this.userInfo.lineUid == "" || this.userInfo.lineUid == null ){
            this.connectLineDialog = true
            return 
          }
          else if( this.userInfo.lineUid && !this.lineFriendToken){
            this.authLine();
          }
          else if(this.lineFriendToken && this.lineFriendToken.startsWith("Bearer ")) { //ป้องกันความผิดพลาดที่ save token ติด Bearer
            await this.setLineFriendToken(null)
            this.authLine();
          }
          else if(this.userInfo.lineUid && this.lineFriendToken){
            await lineAPI.checkStatusFriends({ token : this.lineFriendToken})
            .then((statusFriend) =>{
              if( statusFriend.status == 200){
                if( statusFriend.data.friendFlag){
                  this.isOpen = true;
                }
                else{
                  this.addFriendDialog = true
                }
              }
              else if(statusFriend.data.status == 500){
                this.$notify.error({
                  title: this.$t('components.promotion.error-title-statusline'),
                  message: this.$t('components.promotion.error-message-statusline')
                });
              }
            });
          }
        }
        else{
          this.isOpen = true;
        }
      }
    },
    closeDrawer() {
      this.isOpen = false;
    },
    async authLine() {
      const codeVerifier = this.randomString(48);
      const code_challenge = this.base64UrlEncode(
        await this.digestMessage(codeVerifier)
      );

      this.redirectLine({
        code_challenge,
        channelID: this.restaurantInfo.channelID,
        REDIRECT_URI: this.REDIRECT_URI,
        codeVerifier,
      });
    },
    async goToProfilepage(){
      this.connectLineDialog = false
      this.fullscreenLoading = true;
      this.$router.push({ name: "ProfileSetting" });
    },
    async goToAddFriends(){
      window.location.href = `https://line.me/R/ti/p/${this.restaurantInfo.basicID}`;
    }
  },
};
</script>

<style scoped>
.crm-homedetail-page {
  height: 100vh;
}

.crm-drawer-entry {
  width: 100%;
  height: 53vh;
  margin-top: -3vh;
  max-width: var(--max-width-app);
  max-height: calc(100vh - 47vh);
  background: #ffffff;
  box-shadow: 0px -4px 32px rgba(0, 0, 0, 0.12);
  border-radius: 16px 16px 0px 0px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.crm-drawer-entry h2 {
  font-family: DB Heavent;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  color: #232729;
  margin: 0;
}

.crm-drawer-entry-descript {
  overflow-y: auto;
}

.crm-drawer-entry-descript--error {
  height: calc(100% - 176px);
}

.crm-drawer-entry-descript p {
  font-size: 18px;
}

.crm-drawer-entry-footer {
  margin-top: auto;
}

.text-period {
  font-size: 20px;
  display: flex;
  align-items: center;
  color: #333333;
}
.crm-drawer-error {
  font-size: 16px;
  font-weight: 400;
  color: #ee493d;
  display: flex;
  justify-content: center;
}

.crm-drawer-error label {
  margin-left: 5px;
}

.crm-drawer-entry-point {
  display: flex;
  margin-top: 5px;
}

.crm-drawer-point {
  color: var(--primary);
  font-size: 20px;
  margin-left: 5px;
  margin-top: -3px;
}

.points-text {
  top: 13vh;
  font-weight: 700;
  font-size: 64px;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0em;
}
.points-text-word {
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0em;
}

.break-spaces{
  white-space: break-spaces;
}

.mt--1 {
  margin-top: -1px;
}
.d-flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-out {
  font-size: 18px;
  color: #EE493D;
}
.d-flex-center-row {
  display: flex;
  align-items: center;
}
.tag-pause {
  text-align: center;
  color: #ffffff;
  background: #666666;
  border-radius: 14px;
  width: fit-content;
  padding: 1px 8px;
}
.text-topic-dialog{
  font-weight: 500;
  font-size: 24px;
  color: #333333;
  text-align: center;
  word-break: keep-all;
}
.test-description-dialog{
  font-weight: 400;
  font-size: 20px;
  color: #4F4F4F;
  text-align: center;
  word-break: keep-all;
}
.flex-column{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.el-button {
  font-family: 'DB Heavent';
  font-size: 20px;
}
.ok-btn{
  width: 100%;
  margin-top: 16px;
}
</style>